module.exports = __webpack_public_path__ + "media/bootstrap-icons/gift-fill-118d07e3.svg";